import {onMounted, ref, nextTick, watch, watchEffect} from "vue";
import {useStorage, breakpointsTailwind, useBreakpoints} from "@vueuse/core";

export default (resizableColumns, resizeColumnsDragHandle) => {
    const breakpoints = useBreakpoints(breakpointsTailwind);
    // Add these variables for the resizable columns
    const columnWidths = ref({
        left: breakpoints.greaterOrEqual("xl").value ? 50 : 100,
        right: breakpoints.greaterOrEqual("xl").value ? 50 : 100,
    });
    watchEffect(() => {
        if (breakpoints.greaterOrEqual("xl").value) {
            columnWidths.value = {
                left: 50,
                right: 50,
            };
        } else {
            columnWidths.value = {
                left: 100,
                right: 100,
            };
        }
        if (resizeColumnsDragHandle.value) {
            resizeColumnsDragHandle.value.addEventListener("mousedown", handleDragStart);
        }
    });
    console.log(columnWidths.value, breakpoints.greaterOrEqual("xl").value);
    const isDragging = ref(false);
    const startX = ref(0);
    const startWidth = ref(0);
    // Function to handle the start of dragging
    const handleDragStart = (e) => {
        isDragging.value = true;
        startX.value = e.clientX;
        startWidth.value = columnWidths.value.left;
        // Add event listeners for drag and end events
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("mouseup", handleDragEnd);

        // Prevent text selection during drag
        document.body.style.userSelect = "none";
    };

    // Function to handle dragging
    const handleDrag = (e) => {
        if (!isDragging.value) {
            return;
        }

        // Calculate the new width based on drag distance
        const containerWidth = resizableColumns.value?.clientWidth || 0;
        const deltaX = e.clientX - startX.value;
        const deltaPercent = (deltaX / containerWidth) * 100;

        // Update the column widths (with constraints)
        let newResponseWidth = Math.min(Math.max(startWidth.value + deltaPercent, 20), 80);

        columnWidths.value = {
            left: newResponseWidth,
            right: 100 - newResponseWidth,
        };
    };

    // Function to handle the end of dragging
    const handleDragEnd = () => {
        isDragging.value = false;

        // Remove event listeners
        document.removeEventListener("mousemove", handleDrag);
        document.removeEventListener("mouseup", handleDragEnd);

        // Restore text selection
        document.body.style.userSelect = "";
    };

    return {handleDragStart, isDragging, columnWidths};
};
